module.exports = __webpack_public_path__ + "media/images/svg/home2-92a6109192d8135191c68fa4b4d5c894.svg";